import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import {
  resetCurrentSalesInvoice,
  selectSalesInvoice,
  fetchFinalizedInvoices,
  fetchSalesInvoices,
  fetchSalesInvoiceDetail,
  fetchSalesInvoicesByType,
  finalizeInvoice,
  deliverInvoice,
  voidInvoice,
  voidReturn,
  printInvoice,
  setField,
} from '../../actions/salesInvoice_actions';
import { fetchSalesReturnDetail } from '../../actions/sales_actions';
import { printSalesInvoice, printSalesInvoiceReturn, printSalesInvoiceNoSubtotals, printSalesInvoiceReturnsNoSubtotals } from '../../actions/print_actions';
import { setDefaultDays } from '../../actions/purchaseOrders_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import { setConfirmPasscodeModalVisibility, setPasscodeVerificationStatus } from '../../actions/baseModal_actions';

import SalesInvoice from '../../components/Sales/salesInvoice';

const salesInvoice = reduxForm({
  form: 'salesInvoice',
  destroyOnUnmount: false,
})(SalesInvoice);

const selector = formValueSelector('salesInvoice');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Seller = selector(state, 'Seller');
  const StatusFilter = selector(state, 'StatusFilter');
  const OrderFilter = selector(state, 'OrderFilter');

  return {
    Days,
    FromDate,
    ToDate,
    Seller,
    StatusFilter,
    OrderFilter,
    salesInvoice: state.salesInvoice.all,
    isLoading: state.salesInvoice.isLoading,
    error: state.salesInvoice.error,
    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
    detailIsLoading: state.salesInvoice.detailIsLoading,
    detailError: state.salesInvoice.detailError,
    salesReturnDetail: state.salesInvoice.salesReturnDetail,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
    requestingSalesInvoicePdf: state.print.requestingSalesInvoicePdf,
    salesInvoicePdf: state.print.salesInvoicePdf,
    salesInvoicePdfError: state.print.salesInvoicePdfError,
    requestingSalesInvoiceReturnPdf: state.print.requestingSalesInvoiceReturnPdf,
    salesInvoiceReturnPdf: state.print.salesInvoiceReturnPdf,
    salesInvoiceReturnPdfError: state.print.salesInvoiceReturnPdfError,
    printSalesInvoiceIsLoading: state.print.printSalesInvoiceIsLoading,
    finalizingSalesInvoice: state.salesInvoice.finalizingSalesInvoice,
    deliveringSalesInvoice: state.salesInvoice.deliveringSalesInvoice,
    
    salesorderPdfNs: state.print.salesorderPdfNs,
    requestingSalesInvoicePdfsNs: state.print.requestingSalesInvoicePdfsNs,
    salesInvoiceReturnPdfNs: state.print.salesInvoiceReturnPdfNs,
    
    requestingContainerInvoicePDF: state.print.requestingContainerInvoicePDF,
    containerInvoicePDF: state.print.containerInvoicePDF,
    
    passcodeVerified: state.baseModals.confirmPasscodeModal.verified,
    selectedCompany: state.header.selectedCompany,
  };
}

export default connect(mapStateToProps, {
  setDefaultDays,
  resetCurrentSalesInvoice,
  selectSalesInvoice,
  fetchFinalizedInvoices,
  fetchSalesInvoices,
  fetchSalesInvoiceDetail,
  fetchSalesInvoicesByType,
  finalizeInvoice,
  deliverInvoice,
  voidInvoice,
  voidReturn,
  printInvoice,
  fetchSalesReturnDetail,
  fetchBaseUsers,
  setField,
  checkPassword,
  clearCheckPassword,
  printSalesInvoice,
  printSalesInvoiceReturn,
  printSalesInvoiceNoSubtotals,
  printSalesInvoiceReturnsNoSubtotals,
  setConfirmPasscodeModalVisibility,
  setPasscodeVerificationStatus,
})(salesInvoice);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesInvoice.jsx